/**
 * @generated SignedSource<<55d23df36b22de872c95d3c5a40b7478>>
 * @relayHash d56cfe01460ad4d9ffe80d53cfb30a5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83bc37f98bd776bd60c1c99f39aa37d664da0eb7a194f78e5f1e1747612d6042

import type { ConcreteRequest } from 'relay-runtime';
export type GraphIntegrationSkillToolSource = "INTEGRATIONS_SERVICE" | "%future added value";
export type GraphIntegrationSkillToolType = "PLATFORM_MCP_TOOL" | "%future added value";
export type EditSkillModalQuery$variables = {
  contextAri: string;
  skillAri: string;
};
export type EditSkillModalQuery$data = {
  readonly graphIntegration_skill: {
    readonly description: string;
    readonly id: string;
    readonly instructions: string;
    readonly metadata: {
      readonly tags: ReadonlyArray<string>;
      readonly tools: ReadonlyArray<{
        readonly id: string;
        readonly source: GraphIntegrationSkillToolSource;
        readonly type: GraphIntegrationSkillToolType;
      }>;
    };
    readonly name: string;
    readonly uiMetadata: {
      readonly displayName: string;
    };
  } | null;
};
export type EditSkillModalQuery = {
  response: EditSkillModalQuery$data;
  variables: EditSkillModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillAri"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contextAri",
        "variableName": "contextAri"
      },
      {
        "kind": "Variable",
        "name": "skillAri",
        "variableName": "skillAri"
      }
    ],
    "concreteType": "GraphIntegrationSkill",
    "kind": "LinkedField",
    "name": "graphIntegration_skill",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "instructions"
      },
      {
        "concreteType": "GraphIntegrationSkillUiMetadata",
        "kind": "LinkedField",
        "name": "uiMetadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          }
        ]
      },
      {
        "concreteType": "GraphIntegrationSkillMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "tags"
          },
          {
            "concreteType": "GraphIntegrationSkillTool",
            "kind": "LinkedField",
            "name": "tools",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "source"
              },
              {
                "kind": "ScalarField",
                "name": "type"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditSkillModalQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditSkillModalQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "83bc37f98bd776bd60c1c99f39aa37d664da0eb7a194f78e5f1e1747612d6042",
    "metadata": {},
    "name": "EditSkillModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "de9bf69e026fd33de24954517b4308c5";

export default node;
